import {
  subscriptionConstants,
  globalConstants,
  EMPTY_STRING,
} from "../../constants";

const { SUCCESS } = globalConstants;
const {
  SUBSCRIBE,
  CHANGE_CARD,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTION_PLANS,
  GET_ALL_PLANS,
  FETCH_INVOICE,
} = subscriptionConstants;

const initialState = {
  token: EMPTY_STRING,
  subscriptionPlans: [],
  billingDetails: null,
  subscriptionPlan: null,
  subscriptionDetails: [],
  allSubscriptionPlans: [],
  invoice: null,
};

export const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIBE + SUCCESS:
      return { ...state, token: action.data };
    case GET_SUBSCRIPTION_PLANS + SUCCESS:
      return { ...state, subscriptionPlans: action.data };
    case GET_SUBSCRIPTIONS + SUCCESS:
      return {
        ...state,
        billingDetails: action.data?.revolutPaymentMethod,
        subscriptionPlan: action.data?.subscriptionPlan,
        subscriptionDetails: action.data?.subscriptionDetails,
      };
    case CHANGE_CARD + SUCCESS:
      return { ...state, token: action.data };
    case GET_ALL_PLANS + SUCCESS:
      return { ...state, allSubscriptionPlans: action.data };
    case FETCH_INVOICE + SUCCESS:
      return { ...state, invoice: action.data };

    default:
      return { ...state };
  }
};
